export default [
    {
        id: 'q1',
        title: 'Überholen und Abbiegen',
        explanation: 'Den Mindestabstand zu ungeschützten Verkehrsteilnehmenden wie Radfahrenden einzuhalten, kann Leben retten. Innerorts beträgt dieser 1,5 Meter, außerorts 2 Meter. Wechselt zudem ein Radfahrender die Richtung, muss er das mit einem Handzeichen deutlich zeigen.',
        link: {
            label: 'Testen Sie Ihr Wissen',
            url: 'https://www.runtervomgas.de/mitmachen/pkw-fahrrad-quiz.html'
        },
        image: 'Ueberholen.jpg'
    },
    {
        id: 'q5',
        title: 'Rechtsabbiegen',
        explanation: 'Sicher die Kurve kriegen: Besonders beim Abbiegen müssen Kfz-Führende aufmerksam sein. Denn Radfahrende und zu Fuß Gehende, die eine Kreuzung geradeaus überqueren möchten, haben Vorrang. Damit wirklich niemand übersehen wird, sollten Fahrerinnen und Fahrer beim Abbiegen an den Schulterblick denken.',
        link: {
            label: 'Mehr erfahren',
            url: 'https://www.runtervomgas.de/impulse/artikel/tuecken-beim-rechtsabbiegen.html'
        },
        image: 'RechtsAbbiegen.jpg'
    },
    {
        id: 'q2',
        title: 'Zebrastreifen',
        explanation: 'Ein Zebrastreifen bedeutet nicht: freie Fahrt für Radfahrende. Sie müssen an Fußgängerüberwegen auf den Vorrang von zu Fuß Gehenden achten sowie den sonstigen Verkehr berücksichtigen. Darum gilt: Lieber absteigen und das Rad über den Übergang schieben, denn nur dann hat man Vorrang vor dem Kraftverkehr.',
        link: {
            label: 'Mehr erfahren',
            url: 'https://www.runtervomgas.de/ratgeber-und-service/unfallursachen/vorfahrt-vorrang/'
        },
        image: 'Zebrastreifen.jpg'
    },
    {
        id: 'q4',
        title: 'Ablenkung',
        explanation: 'Ablenkung am Steuer ist eine der Hauptursachen bei Unfällen mit Personenschaden. Auch Radfahrende lassen sich häufig durch zu laute Musik auf den Kopfhörern ablenken. Hören sie dadurch zum Beispiel  Sirenen von Rettungsfahrzeugen nicht und behindern dadurch den Verkehr, droht ihnen ein Bußgeld in Höhe von mindestens 10 Euro.',
        link: {
            label: 'Mehr erfahren',
            url: 'https://www.runtervomgas.de/ratgeber-und-service/unfallursachen/unfall-ablenkung-am-lenkrad/'
        },
        image: 'Ablenkung.png'
    },
    {
        id: 'q3',
        title: 'Radweg',
        explanation: 'Halten oder parken Fahrzeuge auf Radwegen sowie Radfahrstreifen, handeln sie ordnungswidrig. Sie blockieren den Weg und sind ein Sichthindernis für Radfahrende, die sich zum Ausweichen in den fließenden Straßenverkehr einordnen müssen. Denn sie dürfen nicht auf dem Gehweg weiterfahren. Dort müssten sie ihr Rad schieben.',
        link: {
            label: 'Mehr erfahren',
            url: 'https://www.runtervomgas.de/impulse/artikel/radweg-ist-nicht-gleich-radweg.html'
        },
        image: 'HaltenderPKW.png'
    },
    {
        id: 'q6',
        title: 'Dooring',
        explanation: 'Tür-Unfälle zwischen Radfahrenden und parkenden Pkws haben oft schlimme Folgen. Diese lassen sich mit dem holländischen Griff verhindern. Dabei öffnet man die Autotür zur Straßenseite mit der rechten Hand und dreht sich dadurch zur Straße. Per Schulterblick sieht man so alle Verkehrsteilnehmenden.',
        link: {
            label: 'Mehr erfahren',
            url: 'https://www.runtervomgas.de/news/artikel/pas-op.html'
        },
        image: 'Dooring.jpg'
    }
];